import React from "react";
import { Space } from "antd";
import { AxNotes, AxDivider, AxButton } from "@dynata/axiom3";

class ProgrammingNotes extends React.Component {
  render() {
    return (
      <div className="section" id="notes">
        <h3>Programming Notes</h3>
        <p>Axiom compontent for programming notes.</p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`<AxNotes />`}</pre>
            <div className="prop-header">
              <p className="props-title">Props</p>
            </div>

            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Default</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>defaultText</td>
                  <td>Default text</td>
                  <td>string</td>
                  <td></td>
                </tr>
                <tr>
                  <td>multiline</td>
                  <td>
                    To render multiline variant with Read More / Read Less
                    button.
                  </td>
                  <td>boolean</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onEditBegin</td>
                  <td>Called when switched to edit mode.</td>
                  <td>(void) =&gt; void</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onEditEnd</td>
                  <td>Called when the edit mode has ended.</td>
                  <td>(text: string) =&gt; void</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onExpandToggle</td>
                  <td>Called when the `Read More` button is clicked.</td>
                  <td>(event) =&gt; void</td>
                  <td></td>
                </tr>
                <tr>
                  <td>...others</td>
                  <td>
                    All extra props are passed down to the{" "}
                    <>
                      <AxButton
                        size="small"
                        type="link"
                        target="_blank"
                        href="#textarea"
                      >
                        {`<AxTextArea />`}
                      </AxButton>
                    </>{" "}
                    component.
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Single Line
        </AxDivider>

        <Space direction="vertical" size="large">
          <AxNotes />

          <AxNotes defaultText="Laculis est sit aliquam, curabitur hendrerit amet." />
        </Space>

        <AxDivider orientation="left" plain>
          Multi Line
        </AxDivider>

        <Space direction="vertical" size="large">
          <AxNotes
            defaultText="Laculis est sit aliquam, curabitur hendrerit amet. Laculis est sit aliquam, curabitur hendrerit, Laculis est sit aliquam, curabitur hendrerit amet. Laculis est sit aliquam, curabitur hendrerit."
            multiline={true}
          />
        </Space>
      </div>
    );
  }
}
export default ProgrammingNotes;
